module.exports = __webpack_public_path__ + "img/invoice-preview.bbd78abc.jpg";